import { render, staticRenderFns } from "./surveyQuizeEdit.vue?vue&type=template&id=3992886c&scoped=true"
import script from "./surveyQuizeEdit.vue?vue&type=script&lang=js"
export * from "./surveyQuizeEdit.vue?vue&type=script&lang=js"
import style0 from "./surveyQuizeEdit.vue?vue&type=style&index=0&id=3992886c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3992886c",
  null
  
)

export default component.exports